/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ContactSettingFromJSON, ContactSettingToJSON } from './ContactSetting';
export function SiteShareFormFromJSON(json) {
    return SiteShareFormFromJSONTyped(json, false);
}
export function SiteShareFormFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        id: !exists(json, 'id') ? undefined : json['id'],
        isRequired: !exists(json, 'is_required') ? undefined : json['is_required'],
        sort: !exists(json, 'sort') ? undefined : json['sort'],
        createdAt: !exists(json, 'created_at') ? undefined : json['created_at'],
        updatedAt: !exists(json, 'updated_at') ? undefined : json['updated_at'],
        contactSetting: !exists(json, 'contact_setting') ? undefined : ContactSettingFromJSON(json['contact_setting'])
    };
}
export function SiteShareFormToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        id: value.id,
        is_required: value.isRequired,
        sort: value.sort,
        created_at: value.createdAt,
        updated_at: value.updatedAt,
        contact_setting: ContactSettingToJSON(value.contactSetting)
    };
}
